import React, { useContext } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import styled from '@emotion/styled';
import HotelsIntegration from './components/HotelsIntegration';
import RatesIntegration from './components/RatesIntegration';
import RoomsIntegration from './components/RoomsIntegration';
import { LanguageContext } from 'components/language';
import { useSearchParams } from 'react-router-dom';
import Synchronization from './components/Synchronization';

const StyledContainer = styled(Box)`
    padding: 24px;
`;

const TabPanel = ({ children, value, index }) => <div hidden={value !== index}>{value === index && <Box>{children}</Box>}</div>;

const BookingCom = () => {
    const { t } = useContext(LanguageContext);
    const [searchParams, setSearchParams] = useSearchParams();

    const tabValue = parseInt(searchParams.get('tab') || '0', 10);

    const handleTabChange = (event, newValue) => {
        setSearchParams({ tab: newValue.toString() });
    };

    return (
        <StyledContainer>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label={t('HOTELS')} />
                    <Tab label={t('RATES')} />
                    <Tab label={t('ROOMS')} />
                    <Tab label={t('SYNCHRONIZATION')} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <HotelsIntegration />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <RatesIntegration />
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
                <RoomsIntegration />
            </TabPanel>

            <TabPanel value={tabValue} index={3}>
                <Synchronization />
            </TabPanel>
        </StyledContainer>
    );
};

export default BookingCom;
